import React from 'react';
import { SectionConfig } from '../../types';
import { SectionItem } from './SectionItem';

interface SectionProps {
  config: SectionConfig;
}

export function Section({ config }: SectionProps) {
  if (config.render === false) {
    return null;
  }

  return (
    <section className={`section section--${config.name}`} id={config.name}>
      {config.items.map((item, index) => (
        <SectionItem key={`${item.name}-${index}`} config={item} />
      ))}
    </section>
  );
}
